import type { StateService } from "@uirouter/angularjs";
import type { IHttpProvider, ILogService, IRequestConfig } from "angular";
import { module } from "angular";
import "angular-jwt";
import type { IConfig } from "App/Modules/Utils";
import { map, tap } from "rxjs/operators";
import type { ITokenService } from "../Token/ITokenService";
import { AuthInterceptorFunctions } from "./Helpers/AuthInterceptorFunctions";

const appConfig = [
    "jwtInterceptorProvider",
    "jwtOptionsProvider",
    "$httpProvider",
    "irConfig",
    (jwtInterceptorProvider: any, jwtOptionsProvider: any, $httpProvider: IHttpProvider, config: IConfig) => {
        jwtOptionsProvider.config({
            tokenGetter: [
                "options",
                "$log",
                "mmTokenService",
                "$state",
                (options: IRequestConfig, $log: ILogService, tokenService: ITokenService, $state: StateService) => {
                    if (!AuthInterceptorFunctions.IsAuthenticationNeeded(options, config.apiUrl)) {
                        return null;
                    }

                    const accessToken = tokenService.getAccessTokenIfValid();

                    if (accessToken === null) {
                        $log.info(`Login has expired. Refreshing token and holding ${options.url}...`);

                        return tokenService
                            .refreshAccessToken()
                            .pipe(
                                map((response) => response.data.accessToken),
                                tap(
                                    () => {
                                        // No Action
                                    },
                                    () => {
                                        $state.go("login");
                                    },
                                ),
                            )
                            .toPromise();
                    }

                    return accessToken;
                },
            ],
            unauthenticatedRedirectPath: "#!/login",
            whiteListedDomains: [config.apiHostName],
        });

        $httpProvider.interceptors.push("jwtInterceptor");
    },
];

module("mmHttpAuthInterceptor", ["angular-jwt"]).config(appConfig);
